import { createReducer } from 'reduxsauce'
import { Types } from './actions';

const initialState = {
    errorMessage: null
}

const handlers = {
    [Types.SET_ERROR]: (state, {error}) => ({
        ...state,
        errorMessage:error
    })

}

export const errorReducer = createReducer(initialState, handlers);
